import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BenefitStatus } from "src/app/models/benefit-status.model";
import { BenefitTrackerDisplay } from "src/app/models/benefit-tracker-display.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class BenefitService extends BaseService {

    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'employees/[employee-id]/benefits');
    }


  getBenefitStatus() {
    return this.http.get<BenefitStatus[]>(`${this.apiUrl}/status`);
  }

  getBenefitTracker() {
    return this.http.get<BenefitTrackerDisplay[]>(`${this.apiUrl}/benefit-tracker`);
  }

}
